 
export enum RoleType {
  Unknown = 0,
  OptelAdmin = 1,
  OptelSupport = 2,
  TenantAdmin = 3,
  Operator = 4,
  Viewer = 5
}


// WEBPACK FOOTER //
// ./src/types/role-type.ts